import React from 'react';
import './index.css';
import { Toaster } from 'react-hot-toast';

import europe from '../../../assets/images/ModernizationFund/europe.png';
import europeTablet from '../../../assets/images/ModernizationFund/europe.png';
import headerImg from '../../../assets/images/ModernizationFund/header.png';
import footerImg from '../../../assets/images/ModernizationFund/footer.png';

export default () => {
  const desktopBanner = {
    backgroundImage: `url(${europe})`,
  };
  const tabletBanner = {
    backgroundImage: `url(${europeTablet})`,
  };

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="page-content bg-white contactBanner">
        <div
          className="dz-bnr-inr dz-bnr-inr-md text-center overlay-black-middle modernization-fund-banner"
          style={window.innerWidth >= 988 ? desktopBanner : tabletBanner}
        >
          <div className="container">
            <div className="dz-bnr-inr-entry">
              <h1 className="text-white contactTitle">Fondul pentru Modernizare</h1>
            </div>
          </div>
        </div>
      </div>

      <section className="content-inner contactForm">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="modernization-fund-content">
                <div className="modernization-fund-header-logos mb-4">
                  <img src={headerImg} alt="Fondul pentru Modernizare" className="img-fluid" />
                </div>

                {/* ===== ANUNȚ DE ADJUDECARE - MARTIE 2026 ===== */}
                <p className="text-right mb-4"><strong>Martie 2026</strong></p>

                <h1 className="text-center mb-2"><strong>ANUNȚ DE ADJUDECARE</strong></h1>
                <h2 className="text-center mb-5" style={{ fontSize: '1.1rem' }}>
                  privind rezultatul procedurii competitive de achiziție pentru atribuirea contractului de
                  furnizare echipamente și execuție lucrări aferente centralei fotovoltaice pentru proiectul
                  <em>„CONSTRUIRE CENTRALĂ FOTOVOLTAICĂ 900 KW"</em>
                </h2>

                <div className="intro-section mb-5">
                  <p>
                    <strong>ROJEVAS 2000 SRL</strong>, cu sediul social în Județul Galați, Oraș Târgu Bujor, Strada Mecanizatorilor,
                    Nr. 5C, înregistrată la Oficiul Registrului Comerțului cu nr. J2003001479178, având Cod Unic de
                    Înregistrare 15853413, telefon 0744.700.231, email: solomon_vasilica@yahoo.com, în calitate de
                    beneficiar privat, <strong>comunică tuturor ofertanților participanți și publicului interesat rezultatul procedurii
                    competitive de achiziție organizată pentru atribuirea contractului având ca obiect furnizarea
                    echipamentelor și execuția lucrărilor aferente centralei fotovoltaice pentru producerea energiei din
                    surse regenerabile, în cadrul proiectului <em>„CONSTRUIRE CENTRALĂ FOTOVOLTAICĂ 900 KW"</em></strong>,
                    finanțat prin Fondul pentru Modernizare.
                  </p>
                </div>

                <div className="mb-5">
                  <h3><strong>1. Informații privind procedura de achiziție</strong></h3>
                  <p><strong>Tip procedură:</strong> procedură competitivă</p>
                  <p><strong>Tip contract:</strong> furnizare echipamente și execuție lucrări aferente centralei fotovoltaice</p>
                  <p><strong>Data publicării anunțului de lansare a procedurii:</strong> 18.02.2026</p>
                  <p><strong>Termenul limită de depunere a ofertelor:</strong> 10.03.2026, ora 16:30</p>
                  <p><strong>Data deschiderii ofertelor:</strong> 11.03.2026, ora 09:00</p>
                  <p><strong>Criteriul de atribuire:</strong> oferta cea mai avantajoasă din punct de vedere tehnico-financiar, raportat la
                  cerințele minime obligatorii prevăzute în documentația de atribuire</p>
                </div>

                <div className="mb-5">
                  <h3><strong>2. Rezultatul procedurii</strong></h3>
                  <p>
                    În urma procesului de evaluare a documentelor de calificare, a propunerii tehnice și a propunerii
                    financiare, precum și a analizării răspunsurilor la solicitările de clarificări formulate pe parcursul
                    procedurii, comisia de evaluare a constatat că <strong>oferta depusă de SIMTEL TEAM S.A. este conformă
                    și câștigătoare</strong>, îndeplinind toate cerințele prevăzute în documentația de atribuire.
                  </p>
                  <p><strong>Data comunicării rezultatului și a raportului procedurii:</strong> 25.03.2026</p>
                </div>

                <div className="mb-5">
                  <h3><strong>3. Informații privind contractul atribuit</strong></h3>
                  <p><strong>Numărul și data contractului:</strong> Contract de furnizare și execuție lucrări nr. 14 din 26.03.2026</p>
                  <p><strong>Denumirea operatorului economic câștigător:</strong> SIMTEL TEAM S.A., cu sediul social în București,
                  Splaiul Independenței nr. 319L, Clădirea Bruxelles Office Building (corp B), intrarea A, parter, Sector
                  6, CIF: RO 26414626</p>
                  <p><strong>Valoarea contractului:</strong> 2.724.288,58 lei fără TVA, la care se adaugă TVA în valoare de 572.100,60
                  lei (valoare totală cu TVA: 3.296.389,18 lei)</p>
                  <p><strong>Obiectul contractului:</strong> furnizarea și punerea în funcțiune a echipamentelor și execuția lucrărilor
                  aferente centralei fotovoltaice pentru producerea energiei din surse regenerabile pentru proiectul
                  <em>„CONSTRUIRE CENTRALĂ FOTOVOLTAICĂ 900 KW"</em></p>
                </div>

                <div className="mb-5">
                  <h3><strong>4. Raportul procedurii de achiziție</strong></h3>
                  <p>
                    Raportul complet al procedurii de achiziție, poate fi descărcat accesând link-ul de mai jos:
                  </p>
                  <p>
                    <a
                      href="https://www.dropbox.com/scl/fi/ibxhwg9k1zxcmmen1neo5/Raportul-procedurii-nr.-12-din24.03.2026.pdf?rlkey=gxj3qi9k61uoiyuxd8mgi4ehu&st=y6e7dv48&dl=0"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Link Dropbox pentru descărcarea raportului procedurii
                    </a>
                  </p>
                  <p style={{ fontStyle: 'italic' }}>
                    Prezentul anunț se publică în conformitate cu prevederile Ordinului nr. 1561/2024, în termen de 5
                    zile lucrătoare de la data semnării contractului de achiziție.
                  </p>
                </div>

                <hr className="my-5" />

                {/* ===== ANUNȚ PUBLIC - PROCEDURA DE ACHIZIȚIE ===== */}
                <p className="text-right mb-4"><strong>Februarie 2026</strong></p>

                <h1 className="text-center mb-2"><strong>ANUNȚ PUBLIC</strong></h1>
                <h2 className="text-center mb-5" style={{ fontSize: '1.1rem' }}>
                  PRIVIND DEMARAREA PROCEDURII DE ACHIZIȚIE PENTRU ATRIBUIREA CONTRACTULUI
                  DE FURNIZARE ECHIPAMENTE ȘI EXECUȚIE LUCRĂRI AFERENTE CENTRALEI
                  FOTOVOLTAICE PENTRU PRODUCEREA ENERGIEI DIN SURSE REGENERABILE PENTRU
                  PROIECTUL <em>„CONSTRUIRE CENTRALĂ FOTOVOLTAICĂ 900 KW"</em>
                </h2>

                <div className="intro-section mb-5">
                  <p>
                    <strong>ROJEVAS 2000 SRL</strong>, cu sediul social în Județul Galați, Oraș Târgu Bujor, Strada Mecanizatorilor, Nr. 5C, înregistrată la Oficiul Registrului Comerțului cu nr. J2003001479178, având Cod Unic de Înregistrare 15853413, telefon 0744700231, email: solomon_vasilica@yahoo.com, <strong>anunță demararea procedurii de achiziție tip procedura competitiva pentru atribuirea contractului având ca obiect furnizarea echipamentelor și execuția lucrărilor aferente centralei fotovoltaice pentru producerea energiei din surse regenerabile pentru proiectul intitulat <em>„CONSTRUIRE CENTRALĂ FOTOVOLTAICĂ 900 KW"</em></strong>, finanțat prin Fondul pentru Modernizare.
                  </p>
                </div>

                <div className="mb-4">
                  <p><strong>Criteriul de atribuire:</strong></p>
                  <p>
                    Oferta câștigătoare va fi selectată în urma evaluării avantajelor tehnice și financiare prezentate de ofertanți, raportat la cerințele minime obligatorii prevăzute în documentația de atribuire, precum și la elementele suplimentare asumate de aceștia.
                  </p>
                </div>

                <div className="mb-4">
                  <p><strong>Valoarea estimată:</strong> este de 2.725.923,25 lei fără TVA, echivalent a 548.663,18 euro fără TVA (la cursul InforEuro din martie 2024: 1 Euro = 4,9683 lei), din care:</p>
                  <ul>
                    <li>valoarea eligibilă este de 2.077.839,50 lei fără TVA, echivalent a 418.219,41 euro fără TVA;</li>
                    <li>valoarea neeligibilă este de 648.083,75 lei fără TVA, echivalent a 130.443,77 euro fără TVA.</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <p><strong>Tip contract:</strong> furnizare echipamente și execuție lucrări aferente centralei fotovoltaice</p>
                  <p><strong>Dată publicare anunț:</strong> 18.02.2026</p>
                  <p><strong>Termenul limită de depunere a ofertelor:</strong> 10.03.2026, ora 16:30</p>
                  <p><strong>Detalii modalitate transmitere ofertă:</strong> Ofertele se vor transmite la adresa: Județul Galați, Oraș Galați, Strada Clabucet, Nr. 3-5</p>
                </div>

                <div className="mb-5">
                  <p>
                    Cei interesați de prezenta procedură pot consulta documentația de achiziție (inclusiv Caietul de sarcini și anexele acestuia) la următoarea adresă:{' '}
                    <a
                      href="https://www.dropbox.com/scl/fo/1rjh5nv125mv8pgbdm57k/AI4kKOLFfZTRzu1h5Ft4Peo?rlkey=bvcamdokdnrmh3b7tis48mrkt&st=dy1zc8w6&dl=0"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Documentație achiziție (Dropbox)
                    </a>
                  </p>
                  <p>
                    <strong>Mijloace de comunicare:</strong> Orice comunicare legată de această procedură se va face numai în scris la adresa{' '}
                    <a href="mailto:solomon_vasilica@yahoo.com">solomon_vasilica@yahoo.com</a>
                  </p>
                </div>

                <hr className="my-5" />

                {/* ===== COMUNICAT DE PRESĂ ===== */}
                <p className="text-right mb-4"><strong>Noiembrie 2025</strong></p>

                <h1 className="text-center mb-2"><strong>COMUNICAT DE PRESĂ</strong></h1>
                <p className="text-center mb-2">privind începerea implementării proiectului cu titlul</p>
                <h2 className="text-center mb-5"><strong>"CONSTRUIRE CENTRALĂ FOTOVOLTAICĂ 900 KWP"</strong></h2>

                <div className="intro-section mb-5">
                  <p>
                    <strong>ROJEVAS 2000 S.R.L.</strong>, cu sediul social în Loc. Târgu Bujor, Oraș Târgu Bujor, Strada MECANIZATORIILOR, Nr. 5C, Județ Galați, înregistrată la Oficiul Registrului Comerțului cu nr. J2003001479178, având Cod Unic de Înregistrare 15853413, cod poștal 805200, telefon 0744.700.231, email: solomon_vasilica@yahoo.com, <strong>derulează, începând cu data de 12.11.2025, proiectul intitulat <em>"CONSTRUIRE CENTRALĂ FOTOVOLTAICĂ 900 KWP"</em></strong>, finanțat prin Fondul pentru Modernizare - <em>Schema de ajutor de stat privind sprijinirea investițiilor în noi capacități de producere a energiei electrice produsă din surse regenerabile</em>, conform Contract de finanțare nr. 1328 / 12.11.2025.
                  </p>
                </div>

                <div className="objective-section mb-5">
                  <p>
                    <strong>Obiectivul general al proiectului</strong> constă în majorarea producției de energie electrică din surse regenerabile la nivel național, prin înființarea unui parc fotovoltaic în Comuna Vânători, Tarlaua 35, Parcela 92, Lot (2,3,4,5,6)/1, Galați, cu impact asupra modernizării și eficientizării sistemelor energetice, îmbunătățirea eficienței energetice și tranziția spre neutralitate climatică.
                  </p>
                </div>

                <div className="specific-objectives mb-5">
                  <p><strong>Obiectivele specifice ale proiectului sunt:</strong></p>
                  <ol>
                    <li>Diversificarea activității firmei ROJEVAS 2000 S.R.L. prin înființarea unui parc fotovoltaic destinat producerii de energie electrică din surse solare cu o putere instalată de 0,9 MW, în maxim 18 luni de la semnarea contractului de finanțare.</li>
                    <li>Reducerea emisiilor de gaze cu efect de seră cu aproximativ 879,30 tone CO2/an, în perioada de durabilitate a proiectului.</li>
                    <li>Obținerea unei producții brute de energie din surse regenerabile (solar), conform capacității instalate, de 1.437MWh/an, respectiv de 28.740 MWh, în perioada de referință a proiectului (20 de ani).</li>
                    <li>Asigurarea promovării obținerii de energie din surse regenerabile și asigurarea unei implementări fără probleme a proiectului, pe perioada de implementare a proiectului.</li>
                  </ol>
                </div>

                <div className="activities-section mb-5">
                  <p><strong>Activități principale:</strong></p>
                  <ul>
                    <li>Elaborarea și recepția studiului de fezabilitate,</li>
                    <li>Semnarea contractului de finanțare,</li>
                    <li>Managementul și implementarea proiectului,</li>
                    <li>Executarea contractelor încheiate,</li>
                    <li>Obținerea autorizației de construire,</li>
                    <li>Monitorizarea contractelor încheiate.</li>
                  </ul>
                </div>

                <div className="transformation-section mb-5">
                  <p>
                    Proiectul va transforma societatea ROJEVAS 2000 S.R.L. într-un lider al sustenabilității și al utilizării eficiente a resurselor regenerabile, prin îndeplinirea următorilor indicatori:
                  </p>
                </div>

                <div className="indicators-table mb-5">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Indicator</th>
                        <th>Denumire</th>
                        <th>Țintă indicator</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><strong>I.1</strong></td>
                        <td>Capacitate operațională suplimentară instalată de producere a energiei din surse regenerabile</td>
                        <td><strong>0,9 MW</strong></td>
                      </tr>
                      <tr>
                        <td><strong>I.2</strong></td>
                        <td>Reducerea gazelor cu efect de seră: Scăderea anuală estimată a gazelor cu efect de seră</td>
                        <td><strong>879,30 tone CO2/an</strong></td>
                      </tr>
                      <tr>
                        <td><strong>I.3</strong></td>
                        <td>Producția medie de energie din surse regenerabile</td>
                        <td><strong>1.437 MWh/an</strong></td>
                      </tr>
                      <tr>
                        <td><strong>I.4</strong></td>
                        <td>Producția totală de energie din surse regenerabile pentru perioada de referință</td>
                        <td><strong>28.740,00 MWh</strong></td>
                      </tr>
                      <tr>
                        <td><strong>I.5</strong></td>
                        <td>Factorul de capacitate al centralei</td>
                        <td><strong>18,23 %</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="project-details mb-5">
                  <p><strong>Dată începere proiect:</strong> 12.11.2025;</p>
                  <p><strong>Dată finalizare proiect:</strong> 31.12.2026;</p>
                  <p><strong>Valoarea totală eligibilă a proiectului:</strong> 2.077.839,50 lei, echivalentul a 418.219,41 euro;</p>
                  <p><strong>Intensitatea sprijinului nerambursabil:</strong> 200.000,00 euro (47,82 %);</p>
                  <p><strong>Adresa de implementare:</strong> Comuna Vânători, Satul Costi, Tarlaua 35, Parcela 92, LOT (2,3,4,5,6)/1, LOT 1, județul Galați.</p>
                </div>

                <div className="contact-section mb-5">
                  <p><strong>Detalii suplimentare puteți obține de la:</strong></p>
                  <p>Nume persoană de contact: SOLOMON – RADU VASILICĂ</p>
                  <p>Funcție: Administrator</p>
                  <p>Telefon: 0744.700.231</p>
                  <p>E-mail: <a href="mailto:solomon_vasilica@yahoo.com">solomon_vasilica@yahoo.com</a></p>
                </div>

                <div className="modernization-fund-footer-logos mt-5">
                  <img src={footerImg} alt="Fondul pentru Modernizare" className="img-fluid" />
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
